// COMPONENTS
import Navbar from "../../components/navbar/navbar.component";
import Sidebar from "../../components/sidebar/sidebar.component";
import Page from "./page.advancedQuery.page";

const AdvancedQueryLayout = () => {
  return (
    <div className={`h-[calc(100vh-72px)] w-full`}>
      <Navbar />
      <Sidebar>
        <Page />
      </Sidebar>
    </div>
  );
};

export default AdvancedQueryLayout;
